export default "__VITE_ASSET__1ucXFfHs__"